import { render, staticRenderFns } from "./UnsubscribeLayout.vue?vue&type=template&id=6805e51f"
import script from "./UnsubscribeLayout.vue?vue&type=script&lang=js"
export * from "./UnsubscribeLayout.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeLayout.vue?vue&type=style&index=0&id=6805e51f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports